import { OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MultipleChoiceQuestion } from "../../shared/models/multiple-choice-question";
import { QuestionSet } from "../../shared/models/question-set";
import { QuestionType } from 'app/shared/models/question-type';
var QuestionSetComponent = /** @class */ (function () {
    function QuestionSetComponent() {
        // TODO: stephen is the watch taken care with angular2??
        // this._$scope.$watch('questionSet', this.setUpdated.bind(this));
        this.LABEL_SIZE = 6;
        this._isSingleQuestion = false;
        // I believe the isolated scope prevents the ctrl from being bound so
        // assigning this to the ctrl allows us to work with the controller.
    }
    QuestionSetComponent.prototype.ngOnInit = function () {
        this.setupQuestionSet();
    };
    QuestionSetComponent.prototype.ngOnChanges = function (changes) {
        this.setupQuestionSet();
    };
    QuestionSetComponent.prototype.setupQuestionSet = function () {
        this.updateSingleQuestion();
        this.calculateColumnSizes();
    };
    QuestionSetComponent.prototype.updateSingleQuestion = function () {
        if (this.questionSet && this.questionSet.questions.length === 1) {
            this._isSingleQuestion = true;
        }
        else {
            this._isSingleQuestion = false;
        }
    };
    QuestionSetComponent.prototype.calculateColumnSizes = function () {
        if (!this.questionSet) {
            return;
        }
        if (this.questionSet.labels && this.questionSet.labels.length > 6) {
            // keep a minimum of 2 rows for the question.
            this.question_class_size = Math.max(2, 12 - this.questionSet.labels.length);
            this.last_label_size = 1;
        }
        else {
            this.question_class_size = this.LABEL_SIZE;
            this.last_label_size = Math.min(1, this.LABEL_SIZE - this.questionSet.labels.length);
        }
    };
    Object.defineProperty(QuestionSetComponent.prototype, "isSingleQuestion", {
        get: function () {
            return this._isSingleQuestion;
        },
        enumerable: true,
        configurable: true
    });
    QuestionSetComponent.prototype.setUpdated = function (newValue, oldValue) {
        // we want the newest question sets to be on top.
        if (!newValue) {
            return;
        }
        if (newValue.questions && newValue.questions.length === 1) {
            this._isSingleQuestion = true;
        }
        else {
            this._isSingleQuestion = false;
        }
    };
    QuestionSetComponent.prototype.getLabelClasses = function () {
        var labels = this.questionSet.labels.length;
        if (labels < this.LABEL_SIZE) {
            return "col-md-" + (this.LABEL_SIZE - labels);
        }
        return "d-none";
    };
    QuestionSetComponent.prototype.selectLabel = function (qs, label) {
        // this only works with multiple choice questions... doesn't work for anything else
        // TODO: stephen this feels wrong here in this abstraction and suggests we need
        // to rework the conceptual model of question-set's to fix this.
        qs.questions.forEach(function (question) {
            if (question instanceof MultipleChoiceQuestion) {
                question.answer = label;
            }
        });
    };
    QuestionSetComponent.prototype.getQuestionLabels = function (question) {
        return question.CustomLabels;
    };
    // TODO: stephen instead of all these cases would it be better just to dynamically create the components?
    QuestionSetComponent.prototype.isMultipleChoice = function (type) {
        return type == QuestionType.MultipleChoice;
    };
    QuestionSetComponent.prototype.isTextbox = function (type) {
        return type == QuestionType.Textbox;
    };
    QuestionSetComponent.prototype.isChecklist = function (type) {
        return type == QuestionType.Checklist;
    };
    QuestionSetComponent.prototype.isSingleChoice = function (type) {
        return type == QuestionType.SingleChoice;
    };
    return QuestionSetComponent;
}());
export { QuestionSetComponent };



// WEBPACK FOOTER //
// ./src/app/assessments/question-set/question-set.component.ts.pre-build-optimizer.js